// Mutation hook - twarde usuniecie watku PENDING_REVIEW z inbox.
// DELETE /api/ui/sales-crm/notify/threads/{threadId}
// Sprint 4 v4.1.

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IDeleteNotifyThreadResponse } from 'api/types/notify';
import { NOTIFY_INBOX_QUERY_KEY_BASE } from 'api/endpoints/useGetNotifyInbox';

const deleteNotifyThread = (threadId: number): Promise<IDeleteNotifyThreadResponse> =>
  axios.delete(`/sales-crm/notify/threads/${threadId}`);

export const useDeleteNotifyThread = (
  options?: UseMutationOptions<IDeleteNotifyThreadResponse, IError, number>
) => {
  const queryClient = useQueryClient();
  return useMutation<IDeleteNotifyThreadResponse, IError, number>(deleteNotifyThread, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(NOTIFY_INBOX_QUERY_KEY_BASE);
      options?.onSuccess?.(data, variables, context);
    }
  });
};
